
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 11h-7V4a1 1 0 00-1-1 1 1 0 00-1 1v7H4a1 1 0 000 2h7v7a1 1 0 001 1 1 1 0 001-1v-7h7a1 1 0 001-1 1.05 1.05 0 00-1-1z"}})])
          )
        }
      }
    